module.exports = __webpack_public_path__ + "img/碳能科技.27ac9a36.png";